import React from 'react';
import { Box, styled, keyframes } from '@mui/system';

const dotBlink = keyframes`
  0%, 20%   { opacity: 0; }
  50%        { opacity: 1; }
  100%       { opacity: 0; }
`;

const StyledLoading = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '2px',
  '& img': {
    width: 'auto',
    height: '25px'
  },
  '& .loading-text': {
    fontSize: '13px',
    color: '#0284c7',
    display: 'flex',
    alignItems: 'flex-end',
    gap: '1px'
  },
  '& .dot': {
    display: 'inline-block',
    opacity: 0,
    animation: `${dotBlink} 1.4s infinite`
  },
  '& .dot:nth-of-type(2)': { animationDelay: '0.2s' },
  '& .dot:nth-of-type(3)': { animationDelay: '0.4s' }
}));

const Loading = () => {
  return (
    <StyledLoading>
      <Box>
        <img src="/assets/logo/gswm_logo_v2.png" alt="" />
      </Box>
      <span className="loading-text">
        Đang tải dữ liệu
        <span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </span>
    </StyledLoading>
  );
};

export default Loading;
